module.exports = __webpack_public_path__ + "static/img/v4.6088c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v4.png
// module id = e55A
// module chunks = 0